// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {loadTerminalsRequest, loadTerminalsSuccess, deleteTerminalsRequest} from './actionCreators';
import fetch from 'cross-fetch';
import ApiService from '../services/api';
import { showSnackbar } from "../actions/snackbarActions";


export function loadTerminals() {
  return (dispatch, getState) => {
    let state = getState();
    return dispatch(getTerminals(state))
  }
}

function getTerminals(state) {
  let token = state.oidc.user.access_token;
  return dispatch => {
    dispatch(loadTerminalsRequest());
    return fetch(process.env.API_URL + '/api/Terminals', {
      headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then(response => response.json())
      .then(json => dispatch(loadTerminalsSuccess(json)))
  }
}

export const createNew = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const newTerminal = await apiService.createNew("terminals", content);
      dispatch({
        type: 'ADD_TERMINAL_REQUEST',
        data: newTerminal
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const editTerminal = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const editedTerminal = await apiService.edit("terminals", content);
      dispatch({
        type: "TERMINALS_EDIT_TERMINAL",
        data: editedTerminal
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const deleteTerminal = (content) => {
  return async (dispatch, getState) => {
    try {
      dispatch(deleteTerminalsRequest(true));
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const deletedTerminalId = await apiService.delete("terminals", content);
      await dispatch({
        type: "TERMINALS_DELETE_TERMINAL",
        data: deletedTerminalId
      });
      dispatch(showSnackbar("Terminal deleted"))
      dispatch(deleteTerminalsRequest(false));
    }
    catch (err) {
      dispatch(showSnackbar("Error: Terminal delete failed."));
      dispatch(deleteTerminalsRequest(false));
      //throw Error(err);
    }
  }
}

export const loadStatusesAsync = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;
    try {
      let apiService = new ApiService(token);
      const statuses = await apiService.getAll("statuses");
      return statuses;
    }
    catch (ex) {
      console.error(ex);
    }
  }
}

// Termporary solution for loading list
// of terminals for Modals. Currently,
// there aren't any existing implementations
// that allow assign the terminals to a variable.
export const loadTerminalsAsync = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;
    try {
      let apiService = new ApiService(token);
      const terminals = await apiService.getAll("terminals");
      return terminals;
    }
    catch (ex) {
      console.error(ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/terminalActions.js